import React from 'react'

export default function UserHero() {
  return (
    <div className="forget-pass-banner">

      {
        localStorage.getItem("login") && localStorage.getItem("role")==="@A*_s&_k!=!@h!-%"?
        <img src="/images/payment/admin.png" alt="admin-profile" />
        :
        <img src="/images/payment/My-Profile.png" alt="my-profile" />



      }
        </div>
  )
}
